import '../styles/main.css'
import '@/lib/select.js'
import lazim from 'lazim'
import app from '@/app.js'
// import router from '@/router.js'
import { fetchCart } from '@/lib/cart.js'
import '@/lib/jquery-global.js';
import AOS from 'aos'
import '@fancyapps/fancybox'
// import updateThreshold from './lib/threshold'

window.addEventListener('load', AOS.refresh)

var mm = jQuery('.mm');

jQuery('.js-toggle--open').click(function() {
  mm.fadeIn();
  mm.addClass('mm--open');
});

AOS.init({
  delay: 300
})

/**
 * store binding fn
 */
const images = lazim()

/**
 * bind on page load
 */
images()

setTimeout(() => {

  window.scrollTo(0, 0);

  document.body.classList.remove('is-transitioning')

}, 1500)
 



// router.on('after', () => {
//   app.unmount()
//   app.mount()

//   /**
//    * bind new images
//    */
//   images()
// })

// slide up the header as you scroll down

var prevScrollpos = window.pageYOffset;
var body = document.body;

window.onscroll = () => {
  var currentScrollPos = window.pageYOffset;

  if (currentScrollPos > 75) {
    body.classList.add('header--scrolled');
  } else {
    body.classList.remove('header--scrolled');
  }

  prevScrollpos = currentScrollPos;
}


/**
 * load any data that your site needs on fist load
 */
Promise.all([
  fetchCart()
]).then(([ cart ]) => {
  /**
   * add the cart data to the picoapp instance
   */
  app.hydrate({ cart })

  // updateThreshold(cart)

  /**
   * mount any components defined on the page
   */
  app.mount()
})
